import { apiRequest } from './client'
import type { DiscordChannelKey, DiscordChannelMapping, DiscordStatus } from './types'

export const discordApi = {
  status: () => apiRequest<{ data: DiscordStatus }>('/discord/status'),

  listMappings: () => apiRequest<{ data: DiscordChannelMapping[] }>('/discord/mappings'),

  setMapping: (key: DiscordChannelKey, channelId: string) =>
    apiRequest<{ data: DiscordChannelMapping }>(`/discord/mappings/${key}`, { method: 'PUT', body: { channelId } }),

  removeMapping: (key: DiscordChannelKey) => apiRequest<{ data: { success: boolean } }>(`/discord/mappings/${key}`, { method: 'DELETE' }),
}
